import {
  Query,
  getDocs,
  DocumentData,
  QuerySnapshot,
  FirestoreError
} from 'firebase/firestore';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const snapshotToArray = <TData>(snapshot: QuerySnapshot<unknown>): TData[] => {
  const arr: TData[] = [];
  snapshot.forEach((doc) => {
    const data = { id: doc.id, ...(doc.data() as DocumentData) } as TData;
    arr.push(data);
  });
  return arr;
};

export const itemsQueryFn =
  <TData>(itemsQuery: Query<unknown>) =>
  () =>
    getDocs(itemsQuery).then((snapshot) => snapshotToArray<TData>(snapshot));

type UseGetItems<T> = {
  query: Query<unknown>;
  queryKey: (string | undefined)[];
} & UseQueryOptions<T[], FirestoreError, T[], (string | undefined)[]>;

const useGetItems = <TData>({ query, ...rest }: UseGetItems<TData>) =>
  useQuery({
    ...rest,
    queryFn: itemsQueryFn<TData>(query)
  });

export default useGetItems;
